<template>
  <v-text-field
    v-model="identityGuidInput"
    label="IdentityGuid"
    outlined
    dense
    clearable
    @update:model-value="(input) => updateConfig('identityGuid', input)"
  />
  <v-text-field
    v-model="iOrderBrandTokenInput"
    label="iOrderBrandToken"
    outlined
    dense
    clearable
    @update:model-value="(input) => updateConfig('iOrderBrandToken', input)"
  />
  <v-text-field
    v-model="iOrderUsernameInput"
    label="iOrderUsername"
    outlined
    dense
    clearable
    @update:model-value="(input) => updateConfig('iOrderUsername', input)"
  />
  <v-text-field
    v-model="siteIdInput"
    type="number"
    label="SiteID"
    outlined
    dense
    clearable
    @update:model-value="(input) => updateConfig('siteId', input)"
  />
  <v-text-field
    v-model="salesAreaIdInput"
    type="number"
    label="SalesAreaID"
    outlined
    dense
    clearable
    @update:model-value="(input) => updateConfig('salesAreaId', input)"
  />
  <v-text-field
    v-model="iOrderPasswordInput"
    label="iOrderPassword"
    outlined
    dense
    clearable
    @update:model-value="(input) => updateConfig('iOrderPassword', input)"
  />
  <v-text-field
    v-model="identitySecretInput"
    label="identitySecret"
    outlined
    dense
    clearable
    @update:model-value="(input) => updateConfig('identitySecret', input)"
  />
  <v-textarea
    v-model="paymentMethodIdsInput"
    label="PaymentMethodIds"
    outlined
    dense
    clearable
    @update:model-value="(input) => updateConfig('paymentMethodIds', input)"
  />
</template>

<script setup lang="ts">
import { CPullZonalIntegrationConfig } from "@tableyeti/merchant-service/api.ts";
import { ref, watch } from "vue";

const { pullIntegrationConfig } = defineProps<{
  pullIntegrationConfig?: CPullZonalIntegrationConfig | undefined;
}>();
const emit = defineEmits(["update:pullIntegrationConfig"]);

const identityGuidInput = ref<string | undefined>(pullIntegrationConfig?.identityGuid);
const iOrderBrandTokenInput = ref<string | undefined>(pullIntegrationConfig?.iOrderBrandToken);
const iOrderUsernameInput = ref<string | undefined>(pullIntegrationConfig?.iOrderUsername);
const siteIdInput = ref<number | undefined>(pullIntegrationConfig?.siteId);
const salesAreaIdInput = ref<number | undefined>(pullIntegrationConfig?.salesAreaId);
const iOrderPasswordInput = ref<string | undefined>(pullIntegrationConfig?.iOrderPassword);
const identitySecretInput = ref<string | undefined>(pullIntegrationConfig?.identitySecret);
const paymentMethodIdsInput = ref<string | undefined>(
  JSON.stringify(pullIntegrationConfig?.paymentMethodIds, null, 2),
);

const updateConfig = (key: keyof CPullZonalIntegrationConfig, value: string) => {
  if (key === "paymentMethodIds") {
    try {
      const parsedValue = JSON.parse(value);
      emit("update:pullIntegrationConfig", { ...pullIntegrationConfig, [key]: parsedValue });
    } catch (e) {
      console.error("Invalid JSON for paymentMethodIdsInput:", e);
    }
  } else {
    emit("update:pullIntegrationConfig", { ...pullIntegrationConfig, [key]: value });
  }
};

watch(
  () => pullIntegrationConfig,
  (newConfig) => {
    identityGuidInput.value = newConfig?.identityGuid;
    iOrderBrandTokenInput.value = newConfig?.iOrderBrandToken;
    iOrderUsernameInput.value = newConfig?.iOrderUsername;
    siteIdInput.value = newConfig?.siteId;
    salesAreaIdInput.value = newConfig?.salesAreaId;
    iOrderPasswordInput.value = newConfig?.iOrderPassword;
    identitySecretInput.value = newConfig?.identitySecret;
    paymentMethodIdsInput.value = JSON.stringify(newConfig?.paymentMethodIds, null, 2);
  },
  { deep: true },
);
</script>
